import type { Scene } from '../types'

export const openingScenes: Scene[] = [
  {
    id: 'OPEN-01',
    chapter: 'opening',
    route: '/',
    title: 'Cover',
    headline: 'LAMS',
    supporting: 'A purpose-built operational platform for the complete SRWMD land lifecycle.',
    visual: 'cover',
    stageLayout: 'hero',
    sourceRefs: [
      { kind: 'rfp', label: 'Source: SRWMD RFP 26/27-002', locator: 'Title' },
      { kind: 'proposal', label: 'Merlion Technical & Commercial Proposal', locator: 'Title' },
    ],
    presenterNotes: [
      'One sentence of purpose: the District needs the land lifecycle to work as one process, and LAMS is built for exactly that.',
      'Then give the three-part route, once and briefly: who is proposing — Merlion IT and the team chosen for LAMS; the discipline the design is grounded in — Enterprise Asset Management; and the project vision — business, technical and investment.',
      'Do not elaborate on any part here. Move straight to the team.',
    ],
    estimatedSeconds: 45,
    evalTags: ['EVAL-WP'],
  },
]
